import React, { useState, useRef } from 'react'

const parseObjToArray = (inputObject) => {
    let inputArray = []
    Object.keys(inputObject).forEach((key) => {
        let inputProps = inputObject[key]
        inputArray.push(inputProps)
    })
    return inputArray
}

const CustomInput = ({ fieldData, className, formikData, countryCodes, onlyNumbersText }) => {
    const language = localStorage.getItem('customer_language') ?? '22'
    const fieldName = fieldData.su_label_and_options && JSON.parse(fieldData.su_label_and_options)[language]
    const fieldType = fieldData.su_form_variable_type
    const { values, handleChange, handleBlur, touched, errors, setFieldValue } = formikData

    const [onlyNumWarn, setOnlyNumWarn] = useState(false)
    const warnTimerRef = useRef(null)

    const handleCustomChange = (e, attributes) => {
        const value = e.target.value;
        if (attributes.onlyNumber && !/^\d*\.?\d*$/.test(value)) {
            setOnlyNumWarn(true)
            clearTimeout(warnTimerRef.current)
            warnTimerRef.current = setTimeout(() => setOnlyNumWarn(false), 2000)
            return;
        }

        if (attributes.type === 'number' && attributes.maxLength) {
            if (value.length > attributes.maxLength) {
                return;
            }
        }
        handleChange(e);
    }

    //Classes
    const divClasses = {
        text: 'form-floating',
        email: 'form-floating',
        number: 'form-floating',
        checkbox: 'form-check',
        radio: 'form-check'
    }

    const inputClasses = {
        text: 'form-control',
        email: 'form-control',
        number: 'form-control',
        checkbox: 'form-check-input',
        radio: 'form-check-input',
    }

    const labelClasses = {
        checkbox: 'form-check-label',
        radio: 'form-check-label',
    }

    const normalizedCountryCodes = Array.isArray(countryCodes)
        ? countryCodes
            .map((codeObj) => {
                const rawCode = codeObj?.countrycode
                const trimmedCode = rawCode !== undefined && rawCode !== null ? String(rawCode).trim() : ''
                const alpha2 = codeObj?.alpha2 ? String(codeObj.alpha2).trim().toUpperCase() : ''
                return {
                    name: codeObj?.name || '',
                    alpha2,
                    countrycode: trimmedCode
                }
            })
            .filter((codeObj) => codeObj.countrycode !== '' && codeObj.countrycode.toLowerCase() !== 'null')
            .sort((a, b) => {
                const aNum = Number(a.countrycode)
                const bNum = Number(b.countrycode)
                const aIsNum = Number.isFinite(aNum)
                const bIsNum = Number.isFinite(bNum)

                if (aIsNum && bIsNum && aNum !== bNum) return aNum - bNum
                if (aIsNum && !bIsNum) return -1
                if (!aIsNum && bIsNum) return 1

                if (a.countrycode !== b.countrycode) {
                    return a.countrycode.localeCompare(b.countrycode)
                }
                return a.name.localeCompare(b.name)
            })
        : []

    // If it's a standard input type field
    if (fieldType === 1) {
        const inputs = fieldData.su_options && parseObjToArray(JSON.parse(fieldData.su_options))
        if (!inputs)
            return ''

        // Phone/contact number field: busPhone (legacy) OR type === 'number'
        const isPhoneField = inputs[0] && (fieldData.su_name === "busPhone" || inputs[0].type === 'number')
        if (isPhoneField) {
            const countryCodeKey = fieldData.su_name + 'CountryCode'
            const attributes = inputs[0];
            const selectedCountryCode = values[countryCodeKey] || "+44"
            const selectedCountryCodeDigits = String(selectedCountryCode).replace(/\D/g, '').length
            const e164LocalMaxDigits = Math.max(4, 15 - selectedCountryCodeDigits)
            const effectivePhoneMaxLength = attributes?.maxLength
                ? Math.min(Number(attributes.maxLength), e164LocalMaxDigits)
                : e164LocalMaxDigits


            return (
                <div className="col-md-6">
                    <div className={`${className}`} key={fieldName}>
                        <div className="d-flex phone-field-input gap-2">
                            <div className='form-floating code'>
                                <select
                                    name={countryCodeKey}
                                    className="form-control"
                                    value={selectedCountryCode}
                                    onChange={(e) => {
                                        setFieldValue(countryCodeKey, e.target.value);
                                    }}
                                    onBlur={handleBlur}
                                >
                                    {/* <option value="">Select code</option> */}
                                    {normalizedCountryCodes.map((codeObj, index) => (
                                        <option key={`${codeObj.name}-${codeObj.alpha2}-${codeObj.countrycode}-${index}`} value={`+${codeObj.countrycode}`}>
                                            {`${codeObj.alpha2 || codeObj.name} (+${codeObj.countrycode})`}
                                        </option>
                                    ))}
                                </select>
                                {/* <label htmlFor={fieldData.su_name} className="phone-number-hidden-label">
                                    {`${fieldName}${attributes.required ? '*' : ''}`}
                                </label> */}
                            </div>
                            <div className='form-floating flex-grow-1 number phone-number-wrapper'>
                                <input
                                    className={inputClasses[attributes.type]}
                                    id={fieldData.su_name}
                                    name={fieldData.su_name}
                                    onChange={(e) => handleCustomChange(e, attributes)}
                                    onBlur={handleBlur}
                                    maxLength={effectivePhoneMaxLength}
                                    value={values[fieldData.su_name] ?? ""}
                                    placeholder=""
                                />
                                <label htmlFor={fieldData.su_name} className="phone-number-hidden-label">
                                    {`${fieldName}${attributes.required ? '*' : ''}`}
                                </label>
                            </div>
                        </div>
                        {touched[fieldData.su_name] && errors[fieldData.su_name] && (
                            <div className="error">{errors[fieldData.su_name]}</div>
                        )}
                        {onlyNumWarn && attributes?.onlyNumber && <div className="error" style={{ color: '#e65100' }}>{onlyNumbersText || 'Only numbers are allowed'}</div>}
                    </div>
                </div>
            )
        } else {
            const isCheckOrRadio = inputs[0]?.type === 'checkbox' || inputs[0]?.type === 'radio'
            // For all other normal fields (text, email, number, checkbox, radio)
            return (
                <>
                    {
                        inputs[0]?.type !== 'hidden' &&
                        <div className={isCheckOrRadio ? "col-md-12" : "col-md-6"}>
                            <div className={`${divClasses[inputs[0].type]} ${className}`} key={fieldName}>
                                {isCheckOrRadio ? <div className='form-check-wrapper'>
                                    {isCheckOrRadio && <label className="form-check-group-label" htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}

                                    {
                                        inputs?.map((attributes, i) => {
                                            let tmpattributes = { ...attributes }
                                            delete tmpattributes.required
                                            return (
                                                <div className="form-check" key={i}>
                                                    <input
                                                        className={inputClasses[attributes.type]}
                                                        id={`${fieldData.su_lead_gen_variable_id}_${i}`}
                                                        name={fieldData.su_name}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        {...{ ...tmpattributes, value: attributes.type === 'checkbox' || attributes.type === 'radio' ? tmpattributes.value : (values ? (values[fieldData.su_name] ?? "") : "") }}
                                                    />
                                                    {attributes.value && <label className={labelClasses[attributes.type]} htmlFor={`${fieldData.su_lead_gen_variable_id}_${i}`}>{attributes.value}</label>}
                                                </div>
                                            )
                                        })
                                    }
                                    {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}

                                </div> :
                                    <>
                                        {(inputs[0]?.type === 'checkbox' || inputs[0].type === 'radio') && <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}

                                        {
                                            inputs?.map((attributes, i) => {
                                                let tmpattributes = { ...attributes }
                                                delete tmpattributes.required
                                                return (
                                                    <React.Fragment key={i}>
                                                        <input
                                                            className={inputClasses[attributes.type]}
                                                            id={`${fieldData.su_lead_gen_variable_id}_${i}`}
                                                            name={fieldData.su_name}
                                                            onChange={(e) => handleCustomChange(e, attributes)}
                                                            onBlur={handleBlur}
                                                            maxLength={attributes?.maxLength}
                                                            {...{ ...tmpattributes, value: attributes.type === 'checkbox' || attributes.type === 'radio' ? tmpattributes.value : (values ? (values[fieldData.su_name] ?? "") : "") }}
                                                        />
                                                        {attributes.value && <label className={labelClasses[attributes.type]} htmlFor={`${fieldData.su_lead_gen_variable_id}_${i}`}>{attributes.value}</label>}
                                                    </React.Fragment>
                                                )
                                            })
                                        }
                                        {!(inputs[0]?.type === 'checkbox' || inputs[0].type === 'radio') && <label htmlFor={fieldData.su_name}>{`${fieldName}${inputs[0].required ? '*' : ''}`}</label>}
                                        {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                                        {onlyNumWarn && inputs[0]?.onlyNumber && <div className="error" style={{ color: '#e65100' }}>{onlyNumbersText || 'Only numbers are allowed'}</div>}
                                    </>
                                }
                            </div>
                        </div>
                    }
                </>
            )
        }
    }
    else if (fieldType === 3) {
        let attributes = JSON.parse(fieldData.su_options)
        let options = attributes.option

        return (
            <>
                <div className="col-md-6">
                    <div className={className + ` form-floating`} >
                        <select
                            className='form-control'
                            name={fieldData.su_name}
                            id={fieldData.su_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values ? values[fieldData.su_name] : ''}
                        >
                            <option value='' key=''>{attributes.placeholder || '--Select--'}</option>

                            {
                                Object.keys(options).map((key) => (
                                    <option value={key} key={key}>{options[key]}</option>
                                ))
                            }
                        </select>
                        <label htmlFor={attributes.su_name}>{`${fieldName}${attributes.required ? '*' : ''}`}</label>
                        {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                    </div>
                </div>
            </>
        )
    } else if (fieldType === 4) {
        let attributes = JSON.parse(fieldData.su_options)

        return (
            <>
                <div className="col-md-6">
                    <div className={className + ` form-floating`} >
                        <textarea
                            className='form-control'
                            name={fieldData.su_name}
                            id={fieldData.su_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values ? values[fieldData.su_name] : ''}
                            maxLength={attributes?.maxLength || undefined}
                        >
                        </textarea>
                        <label htmlFor={attributes.su_name}>{`${fieldName}${attributes.required ? '*' : ''}`}</label>
                        {touched[fieldData.su_name] && errors[fieldData.su_name] && <div className="error"> {errors[fieldData.su_name]}</div>}
                    </div>
                </div>
            </>
        )
    }
    else if (fieldType === 6) {
        return (
            <div className="col-md-12">
                <div className={className}>
                    <div dangerouslySetInnerHTML={{
                        __html: (fieldName || '')
                            .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ')
                    }} />
                </div>
            </div>
        )
    }
    else {
        return <></>
    }
}

export default CustomInput